import { Audio, Images, Tweens } from "@abcya/abcya_phaser";
import gameData from "../gameData";
import LocalizationUIAssets from "../Localization-UIAssets";
import UIAssetKeys from "../UIAssetKeys";

export default class Newspaper extends Phaser.GameObjects.Container
{
	constructor(scene, type, popup)
	{
		super(scene);

		this.popup = popup;

		this.type = type;

		this.paperCont = null;

		this.paperText = null;
		this.rightText = null;

		this.paper = null;
		this.paper2 = null;
		this.stack = null;

		this.paperCont = this.scene.add.container();
		this.paperCont2 = this.scene.add.container();
		this.stack = Images.addImage(0,0, UIAssetKeys._NewspaperStack, this).setOrigin(0);

		if(this.type === "intro"){
			this.paper = Images.addImage(0,0, LocalizationUIAssets._IntroNewspaper, this.paperCont, Images.LOCALIZATION_ATLAS).setOrigin(0);
		} else {
			Audio.playOneShot("cheer", this.scene);

			this.paper2 = Images.addImage(0,0, UIAssetKeys._ResultsPage, this.paperCont2).setOrigin(0);
			this.createText();
			this.paper = Images.addImage(0,0, UIAssetKeys._EndingNewspaper, this.paperCont).setOrigin(0);
		}

		this.add(this.paperCont2);
		this.add(this.paperCont);

		this.setPosition(-100, -100);
		this.setScale(1.5, 1.5);
		this.alpha = 0;

		const next2 = Images.addImage(this.paper.width/2 + 30, this.paper.height - 60, UIAssetKeys._NextButton, this.paperCont2).setOrigin(0);
		const next = Images.addImage(this.paper.width/2 + 30, this.paper.height - 60, UIAssetKeys._NextButton, this.paperCont).setOrigin(0);

		Tweens.addTween(this, 300, {alpha: 1});
		Tweens.addTween(this, 1000, {scale: 1}, Phaser.Math.Easing.Bounce.Out);
		Tweens.addTween(this, 1000, {x: 50, y: 50}, Phaser.Math.Easing.Bounce.Out, ()=>{
			this.paper.setInteractive();
			this.paper.on('pointerdown', ()=>{

				Audio.playOneShot("newspaper_flip", this.scene);

				this.paper.destroy();
				if(this.paper2) this.paper2.destroy();
				this.stack.destroy();

				if(this.type === "intro"){
					this.scene.moveOn();
				} else {
					this.popup.goHome();
				}
			})
		});
	}

	createText(){
		//console.log("creating results text");
		for(var p = 0; p < gameData.wrongAnswers.length; p++){
			if(p < 20){
				this.paperText = this.scene.add.bitmapText(0, 0, "paperFont", gameData.wrongAnswers[p].noun+gameData.wrongAnswers[p].verb, 20);
				this.rightText = this.scene.add.bitmapText(0, 0, "paperFont", gameData.wrongAnswers[p].noun+gameData.wrongAnswers[p].right, 20);

				this.paperText.setOrigin(.5, .5);
				this.rightText.setOrigin(.5, .5);
				this.paperText.tint = "0x141a35";
				this.rightText.tint = "0x11a00d";
				this.paperCont2.add(this.paperText);
				this.paperCont2.add(this.rightText);

				if(p % 2 === 0){
					this.paperText.x = this.scene.scale.width/2 - this.scene.scale.width/4 - 10;
					this.rightText.x = this.scene.scale.width/2 - this.scene.scale.width/4 - 10;
					this.paperText.y = 210 + (30*p);
					this.rightText.y = this.paperText.y + 20;
				} else {
					this.paperText.x = this.scene.scale.width/2 + this.scene.scale.width/4 - 115;
					this.rightText.x = this.scene.scale.width/2 + this.scene.scale.width/4 - 115;
					this.paperText.y = 210 + (30*(p-1));
					this.rightText.y = this.paperText.y + 20;
				}
			}
		}
	};

	createNextPage = function(sprite){
		//console.log("creating instructions");
		sprite.disableInteractive();

		Audio.playOneShot("newspaper_flip", this.scene);

		game.add.tween(this.paperCont.scale).to({x:.2}, 500, Phaser.Math.Easing.None, true);
		game.add.tween(this.paperCont).to({x:-200, angle:30}, 750, Phaser.Math.Easing.None, true)

		Tweens.addTween(this.paperCont, 500, {scaleX:.2}, Phaser.Math.Easing.None);
		Tweens.addTween(this.paperCont, 750, {x:-200, angle:30}, Phaser.Math.Easing.None, ()=>{
			this.paper2.setInteractive();
			this.paper2.once('pointerdown', ()=>{
				this.cleanUp();
			})
		})
			.onComplete.addOnce(function(){enableUserClick(this.paper2, this.cleanUp, this)}, this);
	};

	cleanUp(){
		//console.log("GOING TO GAME");
		Audio.playOneShot("newspaper_flip", this.scene);

		if(this.type === "intro"){
			this.popup.end();
		} else {
			this.popup.goHome();
		}

		this.paper.destroy();
		if(this.paper2) this.paper2.destroy();
		this.stack.destroy();
	};
}

/*
	me.createNextPage = function(sprite){
		//console.log("creating instructions");
		sprite.inputEnabled = false;

		Audio.playOneShot("newspaper_flip");

		game.add.tween(this.paperCont.scale).to({x:.2}, 500, Phaser.Math.Easing.None, true);
		game.add.tween(this.paperCont).to({x:-200, angle:30}, 750, Phaser.Math.Easing.None, true)
			.onComplete.addOnce(function(){enableUserClick(this.paper2, this.cleanUp, this)}, this);
	};

	me.

	me.cleanUp = function(){
		//console.log("GOING TO GAME");
		A
	};
})();*/